export const requiredScopes = ["public_repo"];
